var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_vm.radioClasses,attrs:{"id":_vm.selectedValue}},[_c('input',{attrs:{"type":"radio","id":_vm.inputId,"name":"formId"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.onRadioChange}}),_c('label',{attrs:{"for":_vm.inputId}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }